import styled from '@emotion/styled';
import { Box } from './box';

export const Status = styled(Box)<{ statusColor: string }>`
  position: relative;
  margin-left: 16px;
  font-size: 12px;
  &:before {
    position: absolute;
    content: '';
    width: 12px;
    height: 12px;
    left: -16px;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    background-color: var(--colorUIRed);
  }
`;
